// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { Messages } from '../../codegen/Localize';
import { Formatters} from '../../codegen/Localize';
import {
  simpleActionErrorMsg,
  simpleActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { ExtractTasks } from '../../extract/resources/ExtractTasks';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { L10n } from '../../ts/L10n/L10n';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { Set } from '../../ts/models/Set';

function execute(extractTasks: Set<IExtractTaskInfo>):  Promise<IResult> {
    let description: string;
    const extractTaskCount = extractTasks.size();
    if (extractTaskCount === 1) {
      const extractTask = extractTasks.first();
      if (extractTask.workbook) {
        description = Messages.extractTaskForResumePausedWorkbookPrompt({
          WORKBOOK_NAME: L10n.elideIfLong(extractTask.workbook.name)
        });
      } else {
        description = Messages.extractTaskForResumePrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
      }
    } else {
      description = Messages.extractTaskForResumePrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
    }

    const dialogConfig = openReactConfirmationDialog<void,IResult>(
    {
      title: Messages.resumeNow(),
      actionName: Messages.resumeNowConfirmButton(),
      action: () => ExtractTasks.resume(extractTasks.keys()),
      message: description,
      paramsForAction: undefined,
      dialogWidth: TabDialogWidth.width375px,
    });

      dialogConfig.result.then((result: IResult) => {
      ContentActionNotification.displaySingleToastForResult({
        items: extractTasks,
        errors: result.errors,
        successMsg: simpleActionSuccessMsg(Messages.extractTasksResumeSuccess),
        errorMsg: simpleActionErrorMsg(Messages.extractTasksResumeError),
      });
    });

    return Promise.resolve(dialogConfig.result);
}

export const ResumeExtractTasksAction = {
    execute
  };

export type ResumeExtractTasksAction = typeof ResumeExtractTasksAction;
